<app-object-edit-table
	[readonly] ="(pSetConfig$ | async) === false"
	[data]="inventoryItems"
	[columns]="inventoryColumns"
	(save)="saveInventoryItems($event)"
></app-object-edit-table>
